export const map = (state) => state.map;

export const data = (state) => state.data;

export const next = (state) => state.next;

export const favoritesMap = (state) =>
  state.map.filter(
    (id) => state.data[id]?.reactions?.bookmarked?.is_mine === true
  );

export const usualSignalsMap = (state) =>
  state.map.filter(
    (id) => state.data[id]?.reactions?.bookmarked?.is_mine !== true
  );

export const isLoading = (state) => state.isLoading;
export const isReady = (state) => state.isReady;
export const isLoadingNext = (state) => state.isLoadingNext;
export const activeSort = (state) => state.activeSort;
export const activeFilter = (state) => state.activeFilter;
export const lastSignals = (state) => state.lastSignals;
export const isLoadingLastSignals = (state) => state.isLoadingLastSignals;
export const readyLastSignals = (state) => state.readyLastSignals;
export const draftForm = (state) => state.draftForm;
export const idEditSignal = (state) => state.idEditSignal;
export const isSignalSendLoading = (state) => state.isSignalSendLoading;